import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import querystring from 'querystring';

import objectFitImages from 'object-fit-images';
window.objectFitImages = objectFitImages;

const context = require.context('../assets/imgs/maps/', true, /\.png$/);
const contextJichitai = require.context('../assets/parent/map', true, /\.png$/);
// context.keys().forEach(context);

const notfound = require('../assets/imgs/notfound.svg');

function getQueries() {
  if (window.location.search.startsWith('?')) {
    return querystring.parse(window.location.search.substring(1));
  } else {
    return {};
  }
}

function replaceElement(newChild, oldChildId) {
  const oldChild = document.getElementById(oldChildId);

  newChild.id = oldChild.id;
  newChild.className = oldChild.className;

  const container = oldChild.parentNode;
  container.replaceChild(newChild, oldChild);
}

export default class App extends Component {
  constructor(props) {
    super(props);

    const queries = getQueries();
    Object.assign(queries, {
      prefecture: queries.prefecture || this.props.initialPrefecture,
      model: props.modelMap[queries.model] ? queries.model :this.props.initialModel,
      period: props.periodMap[queries.period] ? queries.period : this.props.initialPeriod,
    });

    window.history.replaceState(null, null, `?${querystring.stringify(queries)}`);

    this.state = {
      prefecture: queries.prefecture,
      model: queries.model,
      period: queries.period,
    };

    this.form = document.createElement('div');
    replaceElement(this.form, 'form-grid-placeholder');

    this.prefecture = document.createElement('div');
    document.getElementById('prefecture').appendChild(this.prefecture);

    this.leftImage = document.createElement('div');
    replaceElement(this.leftImage, 'left-image');

    this.rightImage = document.createElement('div');
    replaceElement(this.rightImage, 'right-image');
  }

  update() {
    ReactDOM.render(this.renderForm(), this.form);
    if (! this.props.single) {
      ReactDOM.render(this.renderLeftImage(), this.leftImage);
    }
    ReactDOM.render(this.renderRightImage(), this.rightImage);
    ReactDOM.render(this.renderPrefecture(), this.prefecture);
  }

  componentDidMount() {
    this.update();
  }

  componentDidUpdate() {
    let queries = getQueries();
    const {prefecture, model, period} = this.state;
    Object.assign(queries, {prefecture, model, period});
    window.history.replaceState(null, null, `?${querystring.stringify(queries)}`);
    this.update();
  }

  componentWillUnmount() {
    ReactDOM.unmountComponentAtNode(this.form);
    ReactDOM.unmountComponentAtNode(this.contents);
    ReactDOM.unmountComponentAtNode(this.rightImage);
    ReactDOM.unmountComponentAtNode(this.prefecture);
  }

  handleChange = (event) => {
    this.setState({[event.target.name]: event.target.value});
  }

  handleClickImage = (event) => {
    if (event.target.src.endsWith(notfound.replace(/^\.*/, ''))) {
      return;
    }

    window.open(event.target.src, '_blank');
  }

  imageFile(dataset, variable, rcp) {
    let {prefecture, model, period} = this.state;
    return this.props.imageFileFunction(dataset, variable, prefecture, model, rcp, period);
  }

  render() {
    return null;
  }

  renderForm() {
    return (
        <div>
          <label htmlFor="prefecture">都道府県</label>
          <select name="prefecture" value={this.state.prefecture} onChange={this.handleChange}>
            {/* Array.from(this.props.prefectureMap.entries()).map((e) => <option key={e[0]} value={e[0]}>{e[1]}</option>) */}
            {Object.keys(this.props.prefectureMap).map((e) => <option key={e} value={e}>{this.props.prefectureMap[e]}</option>)}
          </select>

          <label htmlFor="model">気候モデル</label>
          <select name="model" value={this.state.model} onChange={this.handleChange}>
            {/* Array.from(this.props.modelMap.entries()).map((e) => <option key={e[0]} value={e[0]}>{e[1]}</option>) */}
            {Object.keys(this.props.modelMap).map((e) => <option key={e} value={e}>{this.props.modelMap[e]}</option>)}
          </select>

          <label htmlFor="period">対象期間</label>
          <select name="period" value={this.state.period} onChange={this.handleChange}>
            {/* Array.from(this.props.periodMap.entries()).map((e) => <option key={e[0]} value={e[0]}>{e[1]}</option>) */}
            {Object.keys(this.props.periodMap).map((e) => <option key={e} value={e}>{this.props.periodMap[e]}</option>)}
          </select>

        </div>
    );
  }

  renderPrefecture() {
    return (
      /* <div>{this.props.prefectureMap.get(this.state.prefecture)}</div> */
      <div>{this.props.prefectureMap[this.state.prefecture]}</div>
    );
  }

  renderLeftImage() {
    return (
      <img src={this.imageFile(this.props.dataset, this.props.variable, this.props.rcpLeft)} alt="" onClick={this.handleClickImage} onError={(e)=> {e.target.src=notfound;}}/>
    );
  }

  renderRightImage() {
    return (
      <img src={this.imageFile(this.props.dataset, this.props.variable, this.props.rcpRight)} alt="" onClick={this.handleClickImage} onError={(e) => {e.target.src=notfound;}}/>
    );
  }
}
